import { useTranslation } from "react-i18next";
import { useOnline } from "../../hooks/useOnline";
export default function OfflineNotice({ message = "offline.connectionRequired" }: { message?: string }) {
    const online = useOnline();
    const { t } = useTranslation("common");
    return online ? null : <p role="status">{t(message)}</p>;
}
